import { createAction, createSlice } from "@reduxjs/toolkit";

const resetPasswordSlice = createSlice({
  name: "resetPassword",
  initialState: { success: null, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      state.success = null;
      /* TODO: reducer for pending*/
    },
    success(state) {
      state.success = true;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.success = false;
      state.processing = false;
      /* TODO: reducer for failure*/
    },
    reset(state) {
      state.success = null;
      state.processing = false;
    },
  },
});

const { name, actions, reducer } = resetPasswordSlice;
const resetPasswordAction = createAction(name);
const resetPasswordResetAction = actions.reset;

export {
  resetPasswordAction,
  resetPasswordResetAction,
  actions as resetPasswordActions,
  reducer as resetPasswordReducer,
};
